import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@bymason-private/legacy-pattern-components';
import { RouterButton } from '@bymason-private/route-provider';
import { routes } from '../../../router';
import { useCallback, useState } from 'react';
import { RequestDeviceModal, useToast } from '@bymason-private/controller-shared-widgets';

export default function TwoUpSection() {
  const [setToastMessage, setToastSeverity] = useToast();
  const [showRequestForm, setShowRequestForm] = useState(false);

  const handleCloseRequestFrom = () => {
    setShowRequestForm(false);
  };

  const handleRequestFormSuccess = useCallback(() => {
    setToastMessage('Successfully submitted request to customer success.');
    setToastSeverity('success');
  }, [setToastMessage, setToastSeverity]);

  const handleRequestFormError = useCallback(() => {
    setToastMessage('Failed to submit request to customer success. Please try again later.');
    setToastSeverity('error');
  }, [setToastMessage, setToastSeverity]);

  const handleBuyNowClick = () => {
    setShowRequestForm(true);
  };

  return (
    <Box sx={{ display: 'flex', gap: 3 }}>
      <Card sx={{ width: '100%' }} elevation={0}>
        <CardMedia
          component='img'
          height='140'
          image='https://mcdn.bymason.com/runway/controller/dashboard/build-in-controller_2x.png'
          alt='Start a New Build'
          sx={{
            background: 'lightGray',
            height: 228,
            width: '100%',
            borderRadius: 5,
            objectFit: 'contain',
            p: 3,
          }}
        />
        <CardContent sx={{ px: 0 }}>
          <Typography variant='h6' fontWeight='bold' component='div'>
            Start a New Build
          </Typography>
          <Typography variant='body2'>
            Build your ideal customer experience using Controller or the Mason CLI. Quickly stand up and save
            new builds.
          </Typography>
        </CardContent>
        <CardActions sx={{ px: 0, gap: 2 }}>
          <RouterButton
            buttonComponent={
              <Button color='secondary' variant='contained'>
                Start now
              </Button>
            }
            route={routes.Projects}
            state={{ create: true }}
          />
          <Button
            color='secondary'
            target='_blank'
            rel='noopener noreferrer'
            variant='text'
            href='https://docs.bymason.com/getting-started/introduction'
          >
            See how it works
          </Button>
        </CardActions>
      </Card>
      <Card sx={{ width: '100%' }} elevation={0}>
        <CardMedia
          component='img'
          height='140'
          image='https://mcdn.bymason.com/runway/controller/dashboard/order-devkits_2x.png'
          alt='Order a Developer Kit'
          sx={{
            background: 'lightGray',
            height: 228,
            width: '100%',
            borderRadius: 5,
            objectFit: 'contain',
            p: 3,
          }}
        />
        <CardContent sx={{ px: 0 }}>
          <Typography variant='h6' fontWeight='bold' component='div'>
            Order a Developer Kit
          </Typography>
          <Typography variant='body2'>
            Build your proof of concept by leveraging the Mason platform, and combining it with a phone,
            tablet or wearable.
          </Typography>
        </CardContent>
        <CardActions sx={{ px: 0 }}>
          <Button color='secondary' variant='outlined' onClick={handleBuyNowClick}>
            Buy now
          </Button>
        </CardActions>
        <RequestDeviceModal
          open={showRequestForm}
          onClose={handleCloseRequestFrom}
          onError={handleRequestFormError}
          onSuccess={handleRequestFormSuccess}
        />
      </Card>
    </Box>
  );
}
